import Offers from './styled';

export default Offers;
